import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Follow } from 'src/lib/entity/live';

@Component({
  selector: 'follower-count',
  templateUrl: './follower-count.component.html',
  styleUrls: ['./follower-count.component.scss', '../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss']
})
export class FollowerCountComponent implements OnInit {

  followerCount: any;
  FollowerCountMagazineId: number;

  constructor(
    private afs: AngularFirestore
  ) { }

  ngOnInit(): void {
  }

  showFollowerCount(magazineId: number) {
    if (magazineId) {
      this.afs.collection<Follow>("follows", ref => {
        return ref
          .where("magazineId", "==", magazineId)
          .where("following", "==", true)
        }).valueChanges()
          .subscribe(x => {
          this.followerCount = x.length
        })
    }
  }

}
